import { TextCell } from "@silevis/reactgrid";
import { ICellTypeHandler } from "components/grecoreactgrid/ICellTypeHandler";
import { SelectAllCellTemplate } from "pages/BankStatements/BankStatementsGrid/customcells/SelectAllCellTemplate";

// Header checkbox of the "select" column: ticks / unticks every invoice that is visible
// with the current search term.
class SelectAllCellTypeHandler implements ICellTypeHandler {
  cellType = "selectall";
  isCustom = true;
  instance = new SelectAllCellTemplate();
  determineNewValue = (change: any) => {
    return (change.newCell as TextCell).text;
  };
  getEntryRow = (
    entry: any,
    columnConfig: any,
    rowsMetadataMap: any,
    keyColumn: string,
    context: {
      [key: string]: any;
    }
  ) => {
    const [{ importedInvoicesSelectAll }, { selectAllImportedInvoices }] =
      context["importedInvoicesStore"];

    return {
      type: "selectall",
      value: importedInvoicesSelectAll,
      checked: importedInvoicesSelectAll,
      onChecked: (checked: boolean) => {
        selectAllImportedInvoices(checked);
      },
    };
  };
}

export default SelectAllCellTypeHandler;
